import React, { useCallback, useEffect, useState } from 'react'
import Accordion from 'components/accordion/Accordion'
import SimpleSelect from 'components/SimpleSelect'
import { IUnControlledSelectProps } from 'select_with_global_state/ISelect'
import withGlobalState, {
  IGlobalStateProps,
} from 'select_with_global_state/WithGlobalState'
import { OfficesRecoilState } from './OfficesState'
import OfficeInfo from 'office/OfficeInfo'
import { IOffice } from 'office/IOffice'
import { reqGetOffices } from 'office/OfficeRequests'

const DEFAULT_OFFICE_ID = 2 // Воронеж, плехановска

interface IOfficeSelectProps
  extends IUnControlledSelectProps,
    IGlobalStateProps<IOffice> {}

const OfficeSelect: React.FC<IOfficeSelectProps> = ({
  defaultItemId,
  items,
  onSelect,
  style,
}) => {
  const [selectedOffice, setSelectedOffice] = useState<IOffice | null>(null)

  useEffect(() => {
    const defaultOfficeId = defaultItemId || DEFAULT_OFFICE_ID
    if (items) {
      const office = items.find((office_) => office_.item_id === defaultOfficeId)
      if (office) {
        setSelectedOffice(office)
      }
    }
  }, [defaultItemId, items])

  const handleSelect = useCallback(
    (officeId) => {
      if (items) {
        const office = items.find((office_) => office_.item_id === officeId)
        if (office) {
          setSelectedOffice(office)
          onSelect(officeId)
        }
      }
    },
    [items, onSelect]
  )

  return (
    <>
      <SimpleSelect defaultItemId={defaultItemId} items={items} onSelect={handleSelect} />
      {selectedOffice && (
        <Accordion header='режим работы' className='px-3'>
          <OfficeInfo office={selectedOffice} />
        </Accordion>
      )}
    </>
  )
}
export default withGlobalState<IUnControlledSelectProps, IOffice>(
  OfficesRecoilState,
  reqGetOffices,
  OfficeSelect
)
